import React from 'react'
import { ChatMessage } from 'types/Chat'
import { messagesToTurns } from 'utils/messagesToTurns'
import { ChatMessageItem } from './ChatMessageItem'
import * as Styled from './ChatMessages.styles'

interface ChatMessagesProps {
  messages: ChatMessage[]
  scrollRef: React.RefObject<HTMLDivElement>
  lastTurnRef: React.RefObject<HTMLDivElement>
  gutterRef: React.RefObject<HTMLDivElement>
}

const ChatMessages: React.FC<ChatMessagesProps> = ({
  messages,
  scrollRef,
  lastTurnRef,
  gutterRef,
}) => {
  const turns = messagesToTurns(messages)

  return (
    <Styled.MessageList ref={scrollRef}>
      <Styled.MessageListInner>
        {turns.map((turn, index) => (
          <Styled.ChatTurn
            key={turn.id}
            ref={index === turns.length - 1 ? lastTurnRef : null}
          >
            {turn.messages.map((message) => (
              <ChatMessageItem key={message.id} message={message} />
            ))}
          </Styled.ChatTurn>
        ))}
        <Styled.BottomGutter ref={gutterRef} />
      </Styled.MessageListInner>
    </Styled.MessageList>
  )
}

export { ChatMessages }
